"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEETING_START_FAILED = exports.MEETING_FAILED = exports.MEETING_ENDED = void 0;
var MEETING_ENDED = exports.MEETING_ENDED = 'meetingEnded';
var MEETING_FAILED = exports.MEETING_FAILED = 'meetingFailed';
var MEETING_START_FAILED = exports.MEETING_START_FAILED = 'meetingStartFailed';